/// <reference path="../../include.ts" />

namespace gpx_visualizer_phase2 {

	import View = alm.view.View;
	import Hash = alm.util.Hash;
	import Num = alm.util.Num;

	export class Terrain extends View<THREE.Object3D> {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		constructor() {
			super(new THREE.Object3D());
			this.initialize();
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		protected implInitialize():THREE.Object3D {
			this.photoTextureErrorDialog = jQuery('#photo-texture-error');
			this.photoTextureErrorDialogMessage = this.photoTextureErrorDialog.find('.message');

			return this.getView();
		}

		protected implReady():void {
			// geometry
			this.setupGeometry();

			// material
			this.setupMaterial();

			// mesh
			this.mesh = new THREE.Mesh(this.geometry, null);
			this.mesh.position.copy(this.center);

			// shadow
			//this.mesh.castShadow = true;
			//this.mesh.receiveShadow = true;

			this.points = new THREE.Points(this.geometry, null);
			this.points.position.copy(this.center);
		}

		private setupGeometry():void {
			const assetLoader = AssetLoader.getInstance();
			const meta = assetLoader.getMeta();
			const dem = assetLoader.getDem();

			// calc bounds
			this.bounds = meta.getBounds();
			this.center = Unit.pixelElevationToSpace(this.bounds.getCenter().getPixel(), Config.terrainElevationOffset, meta.getZoomLevel());

			// create geometry
			const vertexStep:number = 1;

			const originalDimensionX:number = meta.getDemDimensionX();
			const originalDimensionZ:number = meta.getDemDimensionY();

			const dimensionX:number = Math.floor(originalDimensionX / vertexStep);
			const dimensionZ:number = Math.floor(originalDimensionZ / vertexStep);

			const positionTL:THREE.Vector2 = this.bounds.getTopLeft().getPixel();
			const positionBR:THREE.Vector2 = this.bounds.getBottomRight().getPixel();

			const geometrySizeX:number = this.bounds.getPixelWidth();
			const geometrySizeZ:number = this.bounds.getPixelHeight();

			const vertexCount = dimensionX * dimensionZ;
			const geometrySegmentX:number = dimensionX - 1;
			const geometrySegmentZ:number = dimensionZ - 1;

			this.pixelBoundsT = positionTL.y;
			this.pixelBoundsB = positionBR.y;
			this.pixelBoundsL = positionTL.x;
			this.pixelBoundsR = positionBR.x;
			this.pixelElevations = new Array(vertexCount);
			this.geometryDimensionX = dimensionX;
			this.geometryDimensionZ = dimensionZ;

			this.geometry = new THREE.PlaneBufferGeometry(geometrySizeX, geometrySizeZ, geometrySegmentX, geometrySegmentZ);

			const geometryPositions:number[] = <number[]>this.geometry.attributes.position.array;
			//const geometryScales:Float32Array = new Float32Array(vertexCount);

			const vertexColorCount = vertexCount * 3;
			this.vertexColorsFlat = new Float32Array(vertexColorCount);
			this.vertexColorsElevation = new Float32Array(vertexColorCount);
			this.vertexColorsGradient = new Float32Array(vertexColorCount);

			this.defaultPositionsY = new Array(vertexCount);

			const minElevation = dem.getMinElevation();
			const maxElevation = dem.getMaxElevation();

			const elevations:number[] = dem.getElevations();
			const pixelPerMeter:number = Unit.getPixelPerMeter(AssetLoader.getInstance().getMeta().getZoomLevel());

			trace('[TerrainGeometry] vertexCount : ', vertexCount);
			trace('[TerrainGeometry] geometrySegmentX : ', geometrySegmentX);
			trace('[TerrainGeometry] geometrySegmentZ : ', geometrySegmentZ);

			const seaColorR = 0.7;
			const seaColorG = 0.9;
			const seaColorB = 1.0;

			const colorMapElevation = assetLoader.getColorMapElevation();
			const colorMapGradient = assetLoader.getColorMapGradient();

			let index:number = 0;
			let elevationIndex:number = 0;
			let elevationIndexX:number = 0;
			let elevationIndexZ:number = 0;
			for (let z:number = 0; z <= geometrySegmentZ; ++z) {
				const positionZ:number = Num.map(z, 0, geometrySegmentZ, positionTL.y, positionBR.y) - this.center.z;
				for (let x:number = 0; x <= geometrySegmentX; ++x) {
					const positionX:number = Num.map(x, 0, geometrySegmentX, positionTL.x, positionBR.x) - this.center.x;

					// elevation to y
					elevationIndex = z * vertexStep * originalDimensionX + x * vertexStep;
					let elevation = elevations[elevationIndex];

					const isSea = isNaN(elevation);
					if (isSea) elevation = 0;

					let positionY:number = elevation * pixelPerMeter;

					// position
					const index3:number = index * 3;
					geometryPositions[index3    ] = positionX;
					geometryPositions[index3 + 1] = positionY;
					geometryPositions[index3 + 2] = positionZ;

					// flat color
					if (isSea) {
						this.vertexColorsFlat[index3    ] = seaColorR;
						this.vertexColorsFlat[index3 + 1] = seaColorG;
						this.vertexColorsFlat[index3 + 2] = seaColorB;
					} else {
						this.vertexColorsFlat[index3    ] = 1.0;
						this.vertexColorsFlat[index3 + 1] = 1.0;
						this.vertexColorsFlat[index3 + 2] = 1.0;
					}

					// elevation color
					const color = colorMapElevation.getColor(Num.map(elevation, minElevation, maxElevation, 0, 1));
					this.vertexColorsElevation[index3    ] = color.r / 255;
					this.vertexColorsElevation[index3 + 1] = color.g / 255;
					this.vertexColorsElevation[index3 + 2] = color.b / 255;

					this.defaultPositionsY[index] = positionY;
					this.pixelElevations[index] = positionY;

					++index;
					elevationIndexX += vertexStep;
				}
				elevationIndexZ += vertexStep;
			}

			this.vertexColorsFlatAttribute = new THREE.BufferAttribute(this.vertexColorsFlat, 3);
			this.vertexColorsElevationAttribute = new THREE.BufferAttribute(this.vertexColorsElevation, 3);

			this.geometry.addAttribute('color', this.vertexColorsFlatAttribute);
			this.geometry.computeVertexNormals();
			this.geometry.computeBoundingBox();

			// gradient color
			const normals = this.geometry.attributes.normal.array;
			const normal = new THREE.Vector3();
			const up = new THREE.Vector3(0, 1, 0);
			const pi_2 = Math.PI / 2;
			for (let i = 0; i < vertexColorCount; i += 3) {
				normal.set(normals[i], normals[i + 1], normals[i + 2]);
				const dot = normal.dot(up);
				const angle = Math.acos(Math.abs(dot));
				const gradient = Num.map(angle, 0, pi_2, 0, 1);
				//const gradient = Num.map(Math.abs(dot), 1, 0, 0, 1);
				const color = colorMapGradient.getColor(gradient);
				this.vertexColorsGradient[i    ] = color.r / 255;
				this.vertexColorsGradient[i + 1] = color.g / 255;
				this.vertexColorsGradient[i + 2] = color.b / 255;
			}
			this.vertexColorsGradientAttribute = new THREE.BufferAttribute(this.vertexColorsGradient, 3);

			// set legend
			const information = Information.getInstance();
			information.setElevationLegendValue([Math.round(minElevation), Math.round((minElevation + maxElevation) / 2), Math.round(maxElevation)]);
			information.setGradientLegendValue([0, 30, 60, 90]);

			// set scale
			this.setScaleY(Config.terrainElevationMaxScale);
		}

		private setScaleY(scaleY:number):void {
			const geometryPositions:number[] = <number[]>this.geometry.attributes.position.array;
			const vertexCount = this.defaultPositionsY.length;
			for (let i = 0; i < vertexCount; ++i) {
				const positionY = this.defaultPositionsY[i] * scaleY;
				geometryPositions[i * 3 + 1] = positionY;
				this.pixelElevations[i] = positionY;
			}
			this.geometry.computeVertexNormals();
			this.geometry.computeBoundingBox();
		}

		private setupMaterial():void {
			// material
			this.materialsByTerrainType = {};

			this.materialsByTerrainType[TerrainType.None] = new THREE.MeshBasicMaterial();
			this.materialsByTerrainType[TerrainType.WireFrame] = new THREE.MeshBasicMaterial({ color: 0xffffff, wireframe: true, transparent: true });

			//this.materialsByTerrainType[TerrainType.PointCloud] = new THREE.ShaderMaterial(
			//	Object.assign(MaterialUtil.getEmbeddedSgader('pointcloud'), {
			//		uniforms: {
			//			color: { value: new THREE.Color(0xffffff) }
			//		}
			//	})
			//);

			const meshMaterial = new THREE.MeshLambertMaterial({ vertexColors: THREE.VertexColors, side: THREE.DoubleSide });
			this.materialsByTerrainType[TerrainType.Surface] = meshMaterial;
			this.materialsByTerrainType[TerrainType.SurfaceElevation] = meshMaterial;
			this.materialsByTerrainType[TerrainType.SurfaceGradient] = meshMaterial;

			// opacity
			this.maxOpacitiesByTerrainType = {};
			this.maxOpacitiesByTerrainType[TerrainType.None] = 0;
			this.maxOpacitiesByTerrainType[TerrainType.WireFrame] = 0.1;
			//this.maxOpacitiesByTerrainType[TerrainType.PointCloud] = 0.5;
			this.maxOpacitiesByTerrainType[TerrainType.Surface] = 1;
			this.maxOpacitiesByTerrainType[TerrainType.SurfaceElevation] = 1;
			this.maxOpacitiesByTerrainType[TerrainType.SurfaceGradient] = 1;

			if (Config.usePhotoTexture) {

				// pre-loading texture with fallback
				{
					const texture = AssetLoader.getInstance().getPhotoTerrainTexture();
					if (texture) {
						this.materialsByTerrainType[TerrainType.Photo] = new THREE.MeshLambertMaterial({
							map: AssetLoader.getInstance().getPhotoTerrainTexture(),
							side: THREE.DoubleSide,
						});
					} else {
						this.photoTextureErrorDialogMessage.html(Config.errorTerrainPhotoTexture);
						this.materialsByTerrainType[TerrainType.Photo] = new THREE.MeshBasicMaterial({ color: 0x333333, wireframe: true, transparent: true });
					}
					this.maxOpacitiesByTerrainType[TerrainType.Photo] = 1;
				}

 				// pre-loading texture
				/*
				{
					// material
					this.materialsByTerrainType[TerrainType.Photo] = new THREE.MeshLambertMaterial({
						map: AssetLoader.getInstance().getPhotoTerrainTexture(),
						side: THREE.DoubleSide,
					});

					// opacity
					this.maxOpacitiesByTerrainType[TerrainType.Photo] = 1;
				}
				*/

				// post-loading texture
				/*
				{
					// dummy material
					this.materialsByTerrainType[TerrainType.Photo] = new THREE.MeshBasicMaterial({ color: 0x333333, wireframe: true, transparent: true });

					// dummy opacity
					this.maxOpacitiesByTerrainType[TerrainType.Photo] = 1;

					// load texture
					this.photoTextureLoader = new PhotoTextureLoader();
					this.photoTextureLoader.addEventListener(PhotoTextureLoaderEvent.COMPLETE, this.photoTextureLoaderCompleteHandler);
					this.photoTextureLoader.addEventListener(PhotoTextureLoaderEvent.PROGRESS, this.photoTextureLoaderProgressHandler);
					this.photoTextureLoader.addEventListener(PhotoTextureLoaderEvent.ERROR, this.photoTextureLoaderErrorHandler);
					this.photoTextureLoader.load();
				}
				*/
			}
		}

		protected implFinalize():void {
		}

		protected implShow(view:THREE.Object3D, useTransition:boolean):cmd.Command {
			return new cmd.Func(():void => {
			});
		}

		protected implHide(view:THREE.Object3D, useTransition:boolean):cmd.Command {
			return new cmd.Func(():void => {
			});
		}

		public update():void {
		}

		private applyOpacity():void {
			const material:THREE.Material = <THREE.Material>this.mesh.material;
			if (material) {
				const opacity:number = this.maxOpacitiesByTerrainType[this.terrainType];
				if (material.opacity != opacity) {
					material.opacity = opacity;
					material.needsUpdate = true;
				}
			}
		}

		public setTerrainType(oldType:TerrainType, newType:TerrainType):void {
			this.terrainType = newType;
			const view = this.getView();

			if (oldType != null) {
				//if (oldType == TerrainType.PointCloud) {
				//	this.points.visible = false;
				//	this.points.material = null;
				//	view.remove(this.points);
				//} else {
				this.mesh.visible = false;
				this.mesh.material = null;
				view.remove(this.mesh);
				//}
			}

			if (newType != null) {
				if (newType == TerrainType.None) {
					this.mesh.visible = false;
					this.mesh.material = null;
					view.remove(this.mesh);

					//} else if (newType == TerrainType.PointCloud) {
					//	this.points.visible = true;
					//	this.points.material = this.materialsByTerrainType[newType];
					//	view.add(this.points);

				} else {
					this.mesh.visible = true;
					this.mesh.material = this.materialsByTerrainType[newType];

					switch (newType) {
						case TerrainType.Surface:
							this.geometry.attributes.color = this.vertexColorsFlatAttribute;
							this.geometry.attributes.color.needsUpdate = true;
							break;
						case TerrainType.SurfaceElevation:
							this.geometry.attributes.color = this.vertexColorsElevationAttribute;
							this.geometry.attributes.color.needsUpdate = true;
							break;
						case TerrainType.SurfaceGradient:
							this.geometry.attributes.color = this.vertexColorsGradientAttribute;
							this.geometry.attributes.color.needsUpdate = true;
							break;
					}

					view.add(this.mesh);
				}
				this.applyOpacity();
				Information.getInstance().setTerrainType(newType);
			} else {
				Information.getInstance().setTerrainType();
			}

			// post-loading texture
			/*
			if (this.photoTextureLoader) {
				if (this.terrainType == TerrainType.Photo) {
					if (!this.photoTextureLoader.getIsSuccess()) {
						this.photoTextureLoader.showStats();
					}
				} else {
					this.photoTextureLoader.hideStats();
				}
			}
			*/

			// error stats
			if (this.terrainType == TerrainType.Photo) {
				if (!AssetLoader.getInstance().getPhotoTerrainTexture()) {
					this.showPhotoTextureError();
				}
			} else {
				this.hidePhotoTextureError();
			}
		}

		public getY(x:number, z:number):number {
			if (x >= this.pixelBoundsL && x <= this.pixelBoundsR && z >= this.pixelBoundsT && z <= this.pixelBoundsB) {
				const xIndex = Math.floor(Num.map(x, this.pixelBoundsL, this.pixelBoundsR, 0, this.geometryDimensionX - 1));
				const zIndex = Math.floor(Num.map(z, this.pixelBoundsT, this.pixelBoundsB, 0, this.geometryDimensionZ - 1));
				return this.pixelElevations[this.geometryDimensionX * zIndex + xIndex];
			} else {
				return -1;
			}
		}

		public getIntersection(raycaster:THREE.Raycaster):THREE.Intersection {
			const intersects = raycaster.intersectObject(this.mesh);
			return intersects.length > 0 ? intersects[0] : null;
		}

		public showPhotoTextureError(useTransition:boolean = true):void {
			this.photoTextureErrorDialog.css('display', 'block');
		}

		public hidePhotoTextureError(useTransition:boolean = true):void {
			this.photoTextureErrorDialog.css('display', 'none');
		}

		// post-loading texture
		/*
		private photoTextureLoaderCompleteHandler = (event:PhotoTextureLoaderEvent):void => {
			trace('[Terrain] photo texture : load complete');

			// replace material
			this.materialsByTerrainType[TerrainType.Photo] = new THREE.MeshLambertMaterial({
				map: this.photoTextureLoader.getTexture(),
				side: THREE.DoubleSide,
			});

			// apply material
			if (this.terrainType == TerrainType.Photo) {
				this.mesh.material = this.materialsByTerrainType[TerrainType.Photo];
				this.applyOpacity();
			}

			// hide stats
			this.photoTextureLoader.hideStats();
		};

		private photoTextureLoaderProgressHandler = (event:PhotoTextureLoaderEvent):void => {
			trace('[Terrain] photo texture : load complete');
		};

		private photoTextureLoaderErrorHandler = (event:PhotoTextureLoaderEvent):void => {
			trace('[Terrain] photo texture : load error');
		};
		*/





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------

		private bounds:Bounds;
		private terrainType:TerrainType;

		// geometry
		private geometry:THREE.BufferGeometry;
		private geometryDimensionX:number;
		private geometryDimensionZ:number;

		private defaultPositionsY:number[];

		private vertexColorsFlat:Float32Array;
		private vertexColorsFlatAttribute:THREE.BufferAttribute;

		private vertexColorsElevation:Float32Array;
		private vertexColorsElevationAttribute:THREE.BufferAttribute;

		private vertexColorsGradient:Float32Array;
		private vertexColorsGradientAttribute:THREE.BufferAttribute;

		// material
		private materialsByTerrainType:Hash<THREE.Material>;
		private maxOpacitiesByTerrainType:Hash<number>;

		//private photoTextureLoader:PhotoTextureLoader;

		// mesh
		private mesh:THREE.Mesh;
		private points:THREE.Points;
		private center:THREE.Vector3;

		private pixelBoundsT:number;
		private pixelBoundsB:number;
		private pixelBoundsL:number;
		private pixelBoundsR:number;
		private pixelElevations:number[];

		// photo texture
		private photoTextureErrorDialog:JQuery;
		private photoTextureErrorDialogMessage:JQuery;
	}
}
